import React, { Component } from "react";
import { getBoundingClientRect } from "../../../utils/functions";
import EmptyColumn from "./EmptyColumn";
import SectionColumn from "./SectionColumns";

class SectionRow extends Component {
    state = {
        isColSpanStructSelected: false,
        showColSpans: false,
        sectionsSpan: [
            {
                sampleDivs: [{ colSpan: 12, toAddWidth: 0 }]
            },
            {
                sampleDivs: [
                    { colSpan: 6, toAddWidth: 0 },
                    { colSpan: 6, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 4, toAddWidth: 0 },
                    { colSpan: 8, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 8, toAddWidth: 0 },
                    { colSpan: 4, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 4, toAddWidth: 0 },
                    { colSpan: 4, toAddWidth: 0 },
                    { colSpan: 4, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 3, toAddWidth: 0 },
                    { colSpan: 3, toAddWidth: 0 },
                    { colSpan: 3, toAddWidth: 0 },
                    { colSpan: 3, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 2, toAddWidth: 0 },
                    { colSpan: 2, toAddWidth: 0 },
                    { colSpan: 2, toAddWidth: 0 },
                    { colSpan: 2, toAddWidth: 0 },
                    { colSpan: 2, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 }
                ]
            },
            {
                sampleDivs: [
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 },
                    { colSpan: 12, toAddWidth: 0 }
                ]
            }
        ],
        selectedColSpan: null,
        selectedRowSpan: "1fr",
        showSectionsBorder: false
    };

    showSectionFormats = () => {
        console.log("CLICKED");
        this.setState({ showColSpans: true });
    };

    setSelectedColSpan = (colSpan, colSpansIndex) => {
        this.setState(
            {
                selectedColSpan: colSpan,
                isColSpanStructSelected: true,
                colSpansIndex
            },
            () => {
                this.props.setSectionRows(
                    this.props.sectionId,
                    this.props.rowId,
                    colSpan.length
                );
            }
        );
    };

    changeColumnWidth = () => {};

    mouseEnter = () => {
        this.setState({ showSectionsBorder: true });
    };
    mouseLeave = () => {
        this.setState({ showSectionsBorder: false });
    };

    componentDidUpdate() {}
    render() {
        const {
            sectionRowsLength,
            rowColumnsLength,
            sectionId,
            formsRows,
            rowId,
            addnewItem,
            changeInputPosition,
            deleteInput,
            openInputConfig,
            rowColumns
        } = this.props;
        let rowRect =
            this.sectionRowRef && getBoundingClientRect(this.sectionRowRef);
        console.log(rowRect);
        if (
            rowColumnsLength > 0 &&
            this.state.isColSpanStructSelected &&
            this.state.showColSpans
        ) {
            return (
                <div
                    className="page__section__row page__section__row--full"
                    style={{
                        display: "flex",
                        columnGap: "5%",
                        border: this.state.showSectionsBorder
                            ? "1px solid #eeeeeeee"
                            : ""
                    }}
                    ref={(el) => (this.sectionRowRef = el)}
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}
                >
                    {rowColumns.map((row, colIndex) => {
                        const { rowColumnId, columnContent } = row;
                        console.log(row);
                        //
                        let rowLength = columnContent.length;

                        if (!rowLength) {
                            return (
                                <EmptyColumn
                                    colSpan={
                                        this.state.selectedColSpan[colIndex]
                                    }
                                    spanLength={
                                        this.state.selectedColSpan &&
                                        this.state.selectedColSpan.length
                                    }
                                    rowRect={rowRect}
                                    colIndex={colIndex}
                                />
                            );
                        }
                        return <div>dd</div>;
                        //  return (
                        //      <SingleRow
                        //      sectionId={sectionId}
                        //      inputClass={this.props.inputClass}
                        //      formClass={this.props.formClass}
                        // rowContent={rowContent}
                        // rowId={rowId}
                        // formsRows={formsRows}
                        // rowLength={rowLength}
                        // rowIndex={rowIndex}
                        // addnewItem={addnewItem}
                        // openInputConfig={openInputConfig}
                        // changeInputPosition={changeInputPosition}
                        // deleteInput={deleteInput}
                        // displayHandlers={this.state.displayHandlers}
                        // setDisplayHandlers = {() => this.setState({displayHandlers: true})}
                        // />
                        // );
                    })}
                </div>
            );
        }
        if (
            rowColumnsLength == 0 &&
            !this.state.isColSpanStructSelected &&
            !this.state.showColSpans
        ) {
            return (
                <div
                    className={
                        "page__section__row page__section__row--empty" +
                        " empty--border"
                    }
                    ref={(el) => (this.sectionRef = el)}
                >
                    <div
                        className="newcolumn"
                        onClick={() => this.showSectionFormats()}
                    >
                        Add NEW SECTION
                    </div>
                    <div className="newwidget">Or drag widget here </div>
                </div>
            );
        }
        if (
            rowColumnsLength == 0 &&
            !this.state.isColSpanStructSelected &&
            this.state.showColSpans
        )
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexFlow: "column",
                        border: "1px dashed rgb(104, 99, 99)"
                    }}
                >
                    <div
                        style={{
                            fontSize: 10,
                            marginTop: 5
                        }}
                    >
                        SELECT YOUR STRUCTURE
                    </div>
                    <div
                        className={"page__section__row "}
                        style={{
                            display: "flex",
                            flexFlow: "row wrap",
                            justifyContent: "space-between"
                        }}
                        ref={(el) => (this.sectionRef = el)}
                    >
                        {this.state.sectionsSpan.map((col, index) => {
                            return (
                                <SectionColumn
                                    sampleDivs={col.sampleDivs}
                                    setSelectedColSpan={() =>
                                        this.setSelectedColSpan(
                                            col.sampleDivs,
                                            index
                                        )
                                    }
                                    sectionWidth={
                                        this.sectionRef.getBoundingClientRect()
                                            .width
                                    }
                                    sectionHeight={
                                        this.sectionRef.getBoundingClientRect()
                                            .height
                                    }
                                />
                            );
                        })}
                    </div>
                </div>
            );
        return <div>dvdsv</div>;
    }
}

export default SectionRow;
